import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../application/config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();
    const pathFrontEnd = '/governanceroom/clientscitiesprojects/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathView: pathFrontEnd + 'view',
        pathEdit: pathFrontEnd + 'edit',
        endpoint: `${config.endpoints.backend}governanceroom/clientscitiesprojects/getall`,
        endpointDelete: `${config.endpoints.backend}governanceroom/clientscitiesprojects/delete`
    };

    let list = {
        labelTitle: 'Projetos do Municípios',
        fieldsShowOnDelete: ['title'],
        filter: {
            ...profileFilter
        },
        showPrintButtons: true,
        canDelete: true,
        canEdit: true,
        canView: true,
        canAdd: true,
        columns: [
            {
                name: 'observatory_name',
                label: 'Observatório'
            },
            {
                name: 'city_name',
                label: 'Cidade',
                width: '30%'
            },
            {
                name: 'group',
                label: 'Grupo'
            },
            {
                name: 'title',
                label: 'Projeto'
            },
            {
                name: 'is_public_label',
                label: 'Público'
            }
        ],
        ...paths
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={paths.pathAdd}
                labelTitle={list.labelTitle}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
